<!-- Generated template for the LoadingImageComponent component -->
<div class="gifCont" [ngClass]="classCSS">
  <div class="loading-bar-spinner spinner">
    <div class="spinner-icon"></div>
  </div>
  {{ message }}
</div>
